import React from 'react';
import { useTranslation } from 'hooks';
import { EmptyState, Page } from 'components';
import { NotFound as NotFoundBg } from 'resources/images';

const NotFoundScreen = () => {
  const { t } = useTranslation();

  return (
    <Page>
      <EmptyState
        title={t('notFoundPage')}
        image={{ source: NotFoundBg, alt: t('notFoundPage') }}
      />
    </Page>
  );
};

export default NotFoundScreen;
